import { growth } from "@/lib/api";

const KEY = "reelens_ref";
const TTL_MS = 30 * 24 * 3600 * 1000;

// Stores ?ref=CODE for 30 days (last click wins) and counts the visit.
export function captureReferral(search) {
  try {
    const code = new URLSearchParams(search).get("ref");
    if (!code) return;
    const clean = code.trim().toUpperCase().slice(0, 24);
    if (!/^[A-Z0-9]+$/.test(clean)) return;
    growth.referralVisit(clean).then((r) => {
      if (r.valid) localStorage.setItem(KEY, JSON.stringify({ code: clean, ts: Date.now() }));
    }).catch(() => {});
  } catch { /* storage disabled */ }
}

export function getReferralCode() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    if (v && Date.now() - v.ts < TTL_MS) return v.code;
  } catch { /* ignore */ }
  return undefined;
}
